import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AgentsPage } from 'components/configurations/agents/AgentsPage'
import { ClustersPage } from 'components/configurations/clusters/ClustersPage'
import { ManageClusterAccessPage } from 'components/configurations/clusters/manage-cluster-access/ManageClusterAccessPage'
import { ConfigurationsIndexRoutesWrapper } from 'components/configurations/ConfigurationsIndexRoutesWrapper'
import { PrivateNetworkIntegrationsPage } from 'components/configurations/private-network-integrations/PrivateNetworkIntegrationsPage'
import StatusChecksIndex from 'components/status-checks/StatusChecksIndex'
import TestSuitesIndex from 'components/test-suites/TestSuitesIndex'
import { TrackedGremlinRouteElement } from 'components/TrackedGremlinRouteElement'
import useAuth from 'hooks/use-auth'
import {
  orgsIdGet,
  sharedAssetsRequestsApprovePost,
  sharedAssetsRequestsDenyPost,
  testSuitesGet
} from 'utils/endpoints-access'

const ConfigurationsIndex = () => {
  const { hasEndpointAccess, hasEndpointAccessForAll } = useAuth()

  const canManageClusterAccess = hasEndpointAccessForAll([
    sharedAssetsRequestsApprovePost,
    sharedAssetsRequestsDenyPost
  ])

  const canGetTeamInfo = hasEndpointAccess(orgsIdGet)

  const hasViewTestSuitesPrivilege = hasEndpointAccess(testSuitesGet)

  return (
    <Routes>
      <Route element={<ConfigurationsIndexRoutesWrapper />}>
        <Route
          element={
            <TrackedGremlinRouteElement
              loggedIn
              component={<AgentsPage />}
              name="Agents List"
              shouldRenderRoute={canGetTeamInfo}
            />
          }
          path="agents"
        />
        <Route path={'clusters/*'}>
          <Route
            index
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<ClustersPage />}
                name="Kubernetes Clusters List"
              />
            }
          />
          <Route
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<ManageClusterAccessPage />}
                fallbackRedirectTo="/configurations/clusters"
                name="Manage Cluster Access"
                shouldRenderRoute={canManageClusterAccess}
              />
            }
            path="manage/:assetId"
          />
          <Route element={<Navigate replace to="" />} path="*" />
        </Route>
        <Route
          element={
            <TrackedGremlinRouteElement
              loggedIn
              component={<PrivateNetworkIntegrationsPage />}
              name="Private Network Integrations"
            />
          }
          path="private-network-integrations"
        />
      </Route>
      <Route
        element={
          <TrackedGremlinRouteElement
            loggedIn
            component={
              hasViewTestSuitesPrivilege ? (
                <TestSuitesIndex />
              ) : (
                <Navigate to="/" />
              )
            }
            name="Test Suites"
          />
        }
        path="test-suites/*"
      />
      <Route
        element={
          <TrackedGremlinRouteElement
            loggedIn
            component={<StatusChecksIndex />}
            name="Health Checks"
          />
        }
        path="health-checks/*"
      />
      <Route
        element={<Navigate replace to="/configurations/agents" />}
        path="*"
      />
    </Routes>
  )
}

export default ConfigurationsIndex
